

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
   <title>FA Check | Contact us</title>
  <meta name="title" content="FA Check | Contact us">
  <meta name="description" content="Reach out to FA Check for trusted compliance and verification solutions. We’re here to help you streamline your processes.">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
  <link 
    rel="stylesheet" 
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" 
  />
  <!-- Optional Font Awesome for icons -->
  <link 
    rel="stylesheet" 
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" 
  />

  <style>
    /* Custom styles for the toggle button */
    .navbar-toggler.custom-toggler {
      background-color: transparent;
      border: none;
      font-size: 28px;
      color: #fff;
    }

    /* Responsive behavior: hide the navigation menu on screen widths less than 992px */
    @media (max-width: 992px) {
      .navbar-collapse {
        display: none;
      }
      /* Show the menu when the 'show' class is added */
      .navbar-collapse.show {
        display: block;
      }
    }
  </style>
</head>








  <!-- <div class="row text-center " data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
       <h2 style="text-align: center;color: #6ab187;">We are ready connect you with <br>Clients digitally via Globally</h2> 
       <br><br>
       <img  src="assets/contactus.jpg"><br><br>
       <h4 style="padding-left: 1%;text-align: center;color: #6ab187;">Use the form below to drop us an email<br>
        or call us over the phone</h4>

        <p style="text-align: center;">We are here to provide you with more information, answer any query,<br> and create an effectual solution for your organizational needs.</p>
    </div>
  </div>
-->
  <br><br><br> 
  
       <h2 style="color: #5170ff;text-align: center;" >Contact Us</h2>

  <div class="row p-3">
    <div class="col-md-1"></div>
    <div style="font-size: large;" class="col-md-5 mt-3">
            <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.1753329554726!2d80.20422967262267!3d13.024504136323385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267bef2a89bbf%3A0x19ce0d2ef6887347!2sTyche%20Payment%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1773992783279!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1224.383640448856!2d80.20494532233566!3d13.024489008945725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a3eb4658bc6b75b%3A0xf4897200554e2cf5!2sBaabuji%20Venturess!5e0!3m2!1sen!2sin!4v1774413088849!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

    <div style="font-size: 12px;" class="col-md-5 mt-3"    >
<form [formGroup]="submitForm" class="row" >
  <div class="mb-3 col-md-6 ">
    <label for="formGroupExampleInput" class="form-label">First Name  &  Last Name*  
      <span style="color: red;font-size: small;" *ngIf="name?.errors?.['required'] && name?.touched " >(Kindly Enter The Name)</span>
      <span style="color: red;font-size: small;" *ngIf="name?.errors?.['pattern'] && name?.touched " >(Kindly Enter The Valid Name)</span>
      
    </label>
    <input type="text" class="form-control" formControlName="name" id="formGroupExampleInput" pattern="^[A-Za-z0-9\s]*$" placeholder="Firstname & lastname">
  </div>
  <div class="mb-3 col-md-6">
    <label for="formGroupExampleInput2" class="form-label">Business Email* 
      <span style="color: red;font-size: small;" *ngIf="email?.errors?.['required'] && email?.touched " >(Kindly Enter The E-Mail)</span>
      <span style="color: red;font-size: small;" *ngIf="email?.errors?.['pattern'] && email?.touched " >(Kindly Enter The Valid E-Mail)</span>
    </label>
    <input type="text" class="form-control" formControlName="email"  pattern="^[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?$"  id="formGroupExampleInput2" placeholder="Business Email">
  </div>
  <div class="mb-3 col-md-6">
    <label for="formGroupExampleInput2" class="form-label">Mobile Number*
      <span style="color: red;font-size: small;" *ngIf="mobileNumber?.errors?.['required'] && mobileNumber?.touched " >(Kindly Enter The MobileNumber)</span>
      <span style="color: red;font-size: small;" *ngIf="mobileNumber?.errors?.['pattern'] && mobileNumber?.touched " >(Kindly Enter The Valid MobileNumber)</span>
    </label>
    <input (change)="getCaptcha()" type="text" class="form-control" formControlName="mobileNumber" minlength="10" maxlength="10"  pattern="^[0-9]+$"  id="formGroupExampleInput2" placeholder="MobileNumber">
  </div>

<div class="mb-3 col-md-6">
<label for="formGroupExampleInput2" class="form-label">How did you hear about Us?*
  <span style="color: red;font-size: small;" *ngIf="howYouKnow?.errors?.['required'] && howYouKnow?.touched " >(Kindly Select Any One)</span>
  
</label>
<select  formControlName="howYouKnow" class="form-select" id="autoSizingSelect">
    <option selected hidden  value="" >Choose...</option>
    <option value="Referral">Referral</option>
    <option value="Website">Website</option>
    <option value="Social Media">Social Media</option>
    <option value="Others">Others</option>
  </select>
</div>
   
  <div class="mb-3 col-md-12">
    <label for="formGroupExampleInput2" class="form-label">Comments*
      <span style="color: red;font-size: small;" *ngIf="comment?.errors?.['required'] && comment?.touched " >(Kindly Enter The Comments)</span>
      <span style="color: red;font-size: small;" *ngIf="comment?.errors?.['pattern'] && comment?.touched " >(Kindly Enter The Valid Comments)</span>
    </label>

    <textarea class="form-control" rows="3"  pattern="^[A-Za-z0-9\s\-\,\.]*$"  formControlName="comment"   placeholder="Leave a comment here" id="floatingTextarea"></textarea>
  </div>
  <div class="mb-3" *ngIf="receivedCaptcha" >
    <label for="formGroupExampleInput2" class="form-label">Enter Captcha*
      <span style="color: red;font-size: small;" *ngIf="captcha?.errors?.['required'] && captcha?.touched " >(Kindly Enter The Captcha)</span>
      <!-- <span style="color: red;font-size: small;" *ngIf="captcha?.errors?.['pattern'] && captcha?.touched " >(Kindly Enter The Valid Comments)</span> -->
    </label>
<div class="input-group" >
  <input class="form-control captcha barriecito-regular " style="font-size: 14px;"  ondrag="return false"  readonly (copy)="false"  [value]="receivedCaptcha"  id="floatingTextarea">
<button class="btn btn" (click)="getCaptcha()" style="background-color: #5170ff;color: white;font-size: 14px;" >
  <i class="bi bi-arrow-clockwise"></i>
</button>
<input class="form-control" formControlName="captcha" style="font-size: 14px;" (paste)="false" pattern="^[A-Za-z0-9\s\-\,\.]*$"    placeholder="Enter Captcha Here" >

</div>
  </div>
  
  <button *ngIf="!loading"  (click)="submit()" style="background-color: #5170ff;color: white;" class="btn btn">Submit</button>
  <button *ngIf="loading" disabled style="background-color: #5170ff;color: white;" class="btn btn">Loading . . . .     </button>

</form>


    </div>
    <div class="col-md-1"></div>

  </div>

  

  


 
  <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Barriecito&family=Exo+2:ital,wght@0,100..900;1,100..900&family=Special+Elite&display=swap" rel="stylesheet">




  
  
